module.exports = __webpack_public_path__ + "img/20180815_145537_011.3674f1cf.jpg";